import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';

/**
 * Error that is thrown when adding an article fails.
 */
export class AddArticleError extends Error {
  constructor(message: string) {
    super(message);
  }
}

/**
 * Error that is thrown when attaching one article to another fails.
 */
export class AttachArticleError extends AddArticleError {
  constructor(message: string,
              public acceptingArticle: { article: ArticleVO, usage?: ArticleUsageVO },
              public requiringArticle: { article: ArticleVO, usage?: ArticleUsageVO }) {
    super(message);
  }
}

/**
 * Error that is thrown when there is not enough space to add an article.
 */
export class NotEnoughSpaceError extends AddArticleError {
  constructor(message: string) {
    super(message);
  }
}
